import { render } from "./BillingAccountHistory.vue?vue&type=template&id=d3254470&scoped=true&ts=true"
import script from "./BillingAccountHistory.vue?vue&type=script&lang=ts"
export * from "./BillingAccountHistory.vue?vue&type=script&lang=ts"

import "./BillingAccountHistory.vue?vue&type=style&index=0&id=d3254470&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3254470"]])

export default __exports__